import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import backgroundImage from '../../assets/images/Asset-3-100.jpg';
import { LayoutLogin } from './layout/LayoutLogin';
import LanguageSwitcher from '../../components/others/LanguageSwitcher';

import useVersionCheck from "../../hooks/useVersionCheck";

export const LoginScreen = () => {

    useVersionCheck();

    return (
        <Grid container
            sx={{
                background: (theme) => theme.palette.mode === 'dark' ?
                    `url('${backgroundImage}')` :
                    `url('${backgroundImage}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                width: '100vw'
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    zIndex: 1,
                }}
            >
                <LanguageSwitcher />
            </Box>

            <LayoutLogin />
        </Grid>
    )
}